import React from 'react';
import EntityLogo from '../ui/EntityLogo';
import { cn } from '../../lib/utils';
import { nombreRonda } from '../../lib/bracket';

function Lado({ ins, club, logo, placeholder, marcador, ganador, finalizado, destacado }) {
  return (
    <div className={cn('flex items-center justify-between gap-2 px-2 py-1.5',
      ganador && 'font-semibold', destacado && 'bg-primary/10')}>
      <span className="flex min-w-0 items-center gap-1.5">
        {ins
          ? <EntityLogo src={logo} name={club} className="h-5 w-5 shrink-0" />
          : <span className="h-5 w-5 shrink-0 rounded-full border border-dashed border-muted-foreground/40" />}
        <span className={cn('truncate text-sm', !ins && 'text-muted-foreground')}>{ins ? club : (placeholder || 'Por definir')}</span>
      </span>
      {finalizado && <span className="shrink-0 text-sm tabular-nums">{marcador ?? 0}</span>}
    </div>
  );
}

function Juego({ j, highlightIds }) {
  const finalizado = j.estatus === 'finalizado';
  const gLocal = finalizado && (j.marcador_local ?? 0) > (j.marcador_visita ?? 0);
  const gVisita = finalizado && (j.marcador_visita ?? 0) > (j.marcador_local ?? 0);
  const hlLocal = !!(j.local_inscripcion_id && highlightIds?.has(j.local_inscripcion_id));
  const hlVisita = !!(j.visita_inscripcion_id && highlightIds?.has(j.visita_inscripcion_id));
  return (
    <div className="w-52 overflow-hidden rounded-md border bg-card">
      <Lado ins={j.local_inscripcion_id} club={j.local_club} logo={j.local_logo}
        placeholder={j.local_placeholder} marcador={j.marcador_local} ganador={gLocal} finalizado={finalizado} destacado={hlLocal} />
      <div className="border-t" />
      <Lado ins={j.visita_inscripcion_id} club={j.visita_club} logo={j.visita_logo}
        placeholder={j.visita_placeholder} marcador={j.marcador_visita} ganador={gVisita} finalizado={finalizado} destacado={hlVisita} />
    </div>
  );
}

// Arbol de la eliminatoria. juegos = filas de get_bracket (ordenadas por ronda_orden).
export default function BracketView({ juegos = [], highlightIds }) {
  if (!juegos.length) return null;
  const tercero = juegos.filter((j) => j.ronda === 'tercer_lugar');
  const bracket = juegos.filter((j) => j.ronda !== 'tercer_lugar');
  const cols = {};
  bracket.forEach((j) => { (cols[j.ronda_orden] = cols[j.ronda_orden] || []).push(j); });
  const ordenes = Object.keys(cols).map(Number).sort((a, b) => a - b);

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto pb-2">
        <div className="flex gap-6">
          {ordenes.map((o) => {
            const games = cols[o];
            const roundName = nombreRonda(games.length * 2);
            return (
              <div key={o} className="flex min-w-[13rem] flex-col justify-around gap-4">
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{roundName}</p>
                {games.map((j) => <Juego key={j.juego_id} j={j} highlightIds={highlightIds} />)}
              </div>
            );
          })}
        </div>
      </div>
      {tercero.length > 0 && (
        <div className="space-y-2">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Tercer lugar</p>
          {tercero.map((j) => <Juego key={j.juego_id} j={j} highlightIds={highlightIds} />)}
        </div>
      )}
    </div>
  );
}
